// extracted by mini-css-extract-plugin
export default {"root":"ZPabaINIsMYYyx45Jkoj","mainMenu":"YKdKeR20KRmE6kSkPV6K","placeHolderShimmer":"sxe0afQ2jo_JYhvy0d6i"};